import { NgModule } from "@angular/core";
import { AlertInstanceTableComponent } from "ng/src/app/alerts/instances/alert-instance-table.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { CascadeSelectModule } from "primeng/cascadeselect";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DividerModule } from "primeng/divider";
import { InputSwitchModule } from "primeng/inputswitch";
import { FormsModule } from "@angular/forms";
import { SplitButtonModule } from "primeng/splitbutton";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { SharedModule as LBSharedModule } from "ng/src/app/shared/shared.module";
import { ReportModule } from "ng/src/app/reports/report.module";
import { TemplateModule } from "ng/src/app/templates/template.module";

@NgModule({
	declarations: [
		AlertInstanceTableComponent
	],
	exports: [
	],
	imports: [
		CommonModule,
		SharedModule,
		TableModule,
		CascadeSelectModule,
		ButtonModule,
		CardModule,
		DividerModule,
		InputSwitchModule,
		FormsModule,
		SplitButtonModule,
		ConfirmPopupModule,
		LBSharedModule,
		ReportModule,
		TemplateModule
	]
})
export class AlertModule { }